import React, { useState } from 'react';
import { ReorderRuleProduct } from '../ReorderRuleScreen';
import { ActionModal } from '../../../../components/Modal';
import ImportFilePane from '../../../../components/Import/ImportFilePane';
import StockTriggerParsePane from './Panes/StockTriggerParsePane';
import { translate } from '../../../../../types/translation/Translator';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';

enum ImportStatus {
  file,
  parse,
}

interface StockTriggerImportModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;

  reorderRuleProducts: Map<string, ReorderRuleProduct>;
  setReorderRuleProducts: (reorderRuleProducts: Map<string, ReorderRuleProduct>) => void;
}

export default function StockTriggerImportModal({
  open,
  setOpen,
  reorderRuleProducts,
  setReorderRuleProducts,
}: StockTriggerImportModalProps) {
  const [status, setStatus] = useState(ImportStatus.file);
  const [file, setFile] = useState<File | null>(null);

  const content = () => {
    switch (status) {
      case ImportStatus.file:
        return (
          <ImportFilePane
            file={file}
            setFile={setFile}
            acceptedTypes='.csv,.xlsx'
            handleClose={() => setOpen(false)}
            handleNext={() => setStatus(ImportStatus.parse)}
          />
        );
      case ImportStatus.parse:
        if (!file) return null;
        return (
          <StockTriggerParsePane
            file={file}
            handleClose={() => setOpen(false)}
            reorderRuleProducts={reorderRuleProducts}
            setReorderRuleProducts={setReorderRuleProducts}
          />
        );
    }
  };

  return (
    <ActionModal
      open={open}
      setOpen={setOpen}
      title={translate({ key: TranslationKey.parseStockTriggerTitle, count: 'plural' })}
    >
      <div className='h-[600px] px-6 py-4'>{content()}</div>
    </ActionModal>
  );
}
